module.exports = __webpack_public_path__ + "img/073a70d2d47038d8d31cdcd7ad6a643f.png";